module.exports = __webpack_public_path__ + "static/media/prestigerollet.e1faf247.jpg";